import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureComparisonTable = () => {
  const features = [
    {
      category: "Messaging",
      items: [
        { name: "Send Messages", free: "5 per day", premium: "Unlimited" },
        { name: "Read Receipts", free: false, premium: true },
        { name: "Disappearing Messages", free: false, premium: true },
        { name: "Media Sharing", free: "Images only", premium: "All media types" }
      ]
    },
    {
      category: "Search & Discovery",
      items: [
        { name: "Basic Search", free: true, premium: true },
        { name: "Advanced Filters", free: false, premium: true },
        { name: "Online Status", free: false, premium: true },
        { name: "Recently Active", free: false, premium: true }
      ]
    },
    {
      category: "Profile & Privacy",
      items: [
        { name: "Profile Creation", free: true, premium: true },
        { name: "Photo Upload", free: "3 photos", premium: "10 photos" },
        { name: "Priority Visibility", free: false, premium: true },
        { name: "Enhanced Privacy Controls", free: false, premium: true }
      ]
    },
    {
      category: "Support",
      items: [
        { name: "Email Support", free: "48 hours", premium: "24 hours" },
        { name: "Priority Support", free: false, premium: true },
        { name: "Profile Verification", free: false, premium: true }
      ]
    }
  ];

  const renderValue = (value) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="Check" size={20} color="var(--color-success)" />
      ) : (
        <Icon name="X" size={20} color="var(--color-error)" />
      );
    }
    return <span className="text-xs md:text-sm font-medium">{value}</span>;
  };

  return (
    <div className="bg-card rounded-xl shadow-warm overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <h2 className="text-xl md:text-2xl font-heading font-bold">Feature Comparison</h2>
        <p className="text-sm md:text-base text-muted-foreground mt-1">See what you get with Premium</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Feature</th>
              <th className="text-center p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">Free</th>
              <th className="text-center p-3 md:p-4 text-xs md:text-sm font-caption font-semibold bg-primary/5">
                <div className="flex items-center justify-center gap-2">
                  <Icon name="Crown" size={16} color="var(--color-primary)" />
                  <span className="text-primary">Premium</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {features?.map((category, categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                <tr className="bg-muted/30">
                  <td colSpan={3} className="p-3 md:p-4 text-xs md:text-sm font-caption font-semibold">
                    {category?.category}
                  </td>
                </tr>
                {category?.items?.map((item, itemIndex) => (
                  <tr key={itemIndex} className="border-b border-border hover:bg-muted/20 transition-smooth">
                    <td className="p-3 md:p-4 text-xs md:text-sm">{item?.name}</td>
                    <td className="p-3 md:p-4 text-center">{renderValue(item?.free)}</td>
                    <td className="p-3 md:p-4 text-center bg-primary/5">{renderValue(item?.premium)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeatureComparisonTable;